module.exports = __webpack_public_path__ + "static/media/diners-club.8f1a91de.svg";